import type { Language } from "@helpers/I18nHelper";
import Affiliation from "@modules/clientDashboard/Affiliation";
import Fidelity from "@modules/clientDashboard/Fidelity";
import MyOrders from "@modules/clientDashboard/MyOrders";
import NeedHelp from "@modules/clientDashboard/NeedHelp";
import Rewards from "@modules/clientDashboard/Rewards";
import i18next from "i18next";
import type { RouteObject } from "react-router";

export const getPrivateRoutes = (lang: Language): RouteObject[] => {
  const t = (key: string) => i18next.t(`routes.private.${key}`, { lng: lang });

  return [
    {
      element: <MyOrders />,
      path: t("orders"),
      handle: { routeId: "orders" },
    },
    {
      element: <Affiliation />,
      path: t("affiliation"),
      handle: { routeId: "affiliation" },
    },
    {
      element: <Fidelity />,
      path: t("fidelity"),
      handle: { routeId: "fidelity" },
    },
    {
      element: <NeedHelp />,
      path: t("help"),
      handle: { routeId: "help" },
    },
    {
      element: <Rewards />,
      path: t("rewards"),
      handle: { routeId: "rewards" },
    },
  ];
};
